<div class="page-content-wrap contentdata">
  <div class="row">
    <div class="col-md-12">
      <!-- breadcrumb -->
      <div class="breadcrumb-container">
        <div>
          <ul class="breadcrumb">
            <li><a>Reports</a></li>
            <li><a>Farm</a></li>
            <li><a>Provider Summary</a></li>
          </ul>

        </div>
        <div class="icons-container">
          <a routerLink="/home"><img src="../../../../assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>
        </div>
      </div>
      <!-- breadcrumb End -->
      <!-- START FORM VALIDATION STATES -->
      <div class="block">
        <div class="screen_heading_div">
          <span>Provider Summary</span>
        </div>
        <div class="Reports_form_div">
          <form role="form" name="addmapdevice" [formGroup]="registerForm">
            <div class="reports-form-container" (clickOutside)="isDropdownOpen = false">
              <div class="form-field custom-select" *ngIf="loginPersonType == 'EMPLOYEE'">
                <input type="text" id="businessname" class="form-control select" autocomplete="off"
                       formControlName="businessfield" (click)="isDropdownOpen = true"
                       [ngClass]="{ 'is-invalid': submitted && f.businessfield.errors }" placeholder=""
                       (keyup)="filterBusinesses($event)" [(ngModel)]="businessSearch" (focus)="businessSearch=''; filteredOptions = businessEntities">
                <label for="businessname">Business Name</label>
                <div class="dropdown-options" *ngIf="isDropdownOpen">
                  <div class="option" *ngFor="let option of filteredOptions" (click)="selectOption(option)">
                    {{ option.businessName }}
                  </div>
                </div>
                <span class="custom-arrow"></span>
                <div *ngIf="submitted && f.businessfield.errors">
                  <div *ngIf="f.businessfield.errors.required" class="field-validation-error-message">
                    <img src="../../../../../../assets/images/New_Icons/error-message.svg" height="20px" width="20px">
                    <span>Required</span>
                  </div>
                </div>
              </div>
              <div class="form-field disbledCls" *ngIf="loginPersonType == 'Farmer' || loginPersonType == 'Farm Manager' || loginPersonType == 'Business Admin'">
                <input type="text" class="form-control" autocomplete="off"
                       formControlName="businessfield" id="businessname"
                       [ngClass]="{ 'is-invalid': submitted && f.businessfield.errors }">
                <label for="businessname">Business Name</label>
                <div *ngIf="submitted && f.businessfield.errors">
                  <div *ngIf="f.businessfield.errors.required" class="field-validation-error-message">
                    <img src="../../../../../../assets/images/New_Icons/error-message.svg" height="20px" width="20px">
                    <span>Required</span>
                  </div>
                </div>
              </div>
              <div class="form-field custom-select"></div>
              <div class="form-field">
                <div class="buttons-div reports_search_div culture-search">
                  <div class="transactions-button-container" (click)="providerSummary()">
                    <button class="transaction-submit-button" [disabled]="submitButtondisabled">
                      <span class="icon"><img src="../../../../../../assets/images/New_Icons/search-icon.svg"></span>
                      <span class="text">Search</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
      </div>
      <!--display data in table format-->
        <div *ngIf="responseLoader">
          <div class="adjust loader-container">
            <div class="loader2"></div>
          </div>
        </div>
      <div class="panel panel-default"
           *ngIf="dupProviderSummaryList && dupProviderSummaryList.length > 0 && !responseLoader">
        <div class="search_cum_icons_button_container">
          <div class="search-div">
            <img src="../../../../../../assets/images/New_Icons/search-icon.svg">
            <input type="text" (keyup)="searchProviderSummary($event)" [(ngModel)]="search"
                   name="search" autocomplete="off" placeholder="Search by section name, pond name">
          </div>
          <div class="add-button-container">
            <img src="../../../../../../assets/images/New_Icons/excel-download-icon.svg" (click)="exportExcel()">
          </div>
        </div>
        <div class="providerData">
          <span>{{loginProviderSummaryList[0] && loginProviderSummaryList[0].businessName}}</span>
          <span>{{loginProviderSummaryList[0] && loginProviderSummaryList[0].device && loginProviderSummaryList[0].device.number}}</span>
        </div>
        <div class="panel-body table-responsive">
          <table class="table table-striped table-bordered table-hover text-centre">
            <thead>
            <tr>
              <th>Farm Name</th>
              <th># Tanks</th>
              <th>Assigned Device</th>
              <th>Barcode Sequence</th>
            </tr>
            </thead>
            <tbody>
            <tr
              *ngFor="let list of providerSummaryList |  paginate: { itemsPerPage: noOfItemsPerPage, currentPage: currentPageNumber }; let i = index">
              <td>{{list && list.businessName}}</td>
              <td>{{list && list.customerPond && list.customerPond.totalPonds}}</td>
              <td>{{list && list.device && list.device.number}}</td>
              <td>{{list && list.barcode_sequence}}</td>
            </tr>
            </tbody>
          </table>
          <div *ngIf="NoDataMessage" class="noDataFoundMessage">No Data Available</div>
          <div class="pagination-container" *ngIf="providerSummaryList && providerSummaryList.length > 0">
            <div class="items-per-page-block">
              <span class="items-per-page">Items per page</span>
              <div class="items-per-page-count-list form-field">
                <select class="form-control select" id="itemscount" autocomplete="off" (change)="noOfItemsPerPage = $event.target.value;currentPageNumber = 1;
              providerSummaryList = dupProviderSummaryList;search = '';NoDataMessage = false">
                  <option value="15" selected>15</option>
                  <option value="25" *ngIf="dupProviderSummaryList && dupProviderSummaryList.length > 15">25</option>
                  <option value="35" *ngIf="dupProviderSummaryList && dupProviderSummaryList.length > 25">35</option>
                  <option value="45" *ngIf="dupProviderSummaryList && dupProviderSummaryList.length > 35">45</option>
                </select>
                <span class="pagination-custom-down-arrow"></span>
              </div>
              <span class="items-per-page">1 - {{noOfItemsPerPage}} of {{dupProviderSummaryList && dupProviderSummaryList.length}} items</span>
            </div>
            <div class="page-selection-div" *ngIf="noOfItemsPerPage != providerSummaryList.length">
              <pagination-controls (pageChange)="currentPageNumber = $event" (click)="pageChange(currentPageNumber)" maxSize="5"></pagination-controls>
            </div>
          </div>
        </div>
      </div>
      <!--display data in table format end-->
    </div>
  </div>
</div>
